<template>
  <SectionTemplate
    title="从创作到互动，有言一站式PPT智能升级"
    desc="与PPT Speak协同，有言还提供从AI生成PPT、PPT转视频到可交互智能体的完整工具链，全面解放您的生产力。"
    class="create-interactive"
  >
    <div class="avatar-detail-container">
      <VideoTabs
        v-for="item in items"
        :desc="item.desc"
        :title="item.title"
        :muted="isMuted"
        :tabs="item.tabs"
      >
        <template #button-group>
          <div class="section-footer">
            <StartBtn
              :widthStyle="{ width: '178px', height: '48px' }"
              :handler="() => handler(item.url, '_blank')"
              text="免费试用"
            />
            <button class="view-detail-btn" @click="onDetail(item.tabs[0].id)">查看详情</button>
          </div>
        </template>
      </VideoTabs>
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import { useRouter } from 'vue-router';
import StartBtn from '~/design/components/buttons/start-btn.vue';
import VideoTabs from '~/design/widgets/multi-tabs-video/index.vue';

const props = defineProps<{
  handler: (url: string, target: string) => void;
}>();

const router = useRouter();
const isMuted = inject<boolean>('isMuted') || true;

const items = [
  {
    title: 'AIPPT',
    desc: '告诉AI你想要演讲的内容主题，或上传已经准备好的演讲文案，AI自动提取关键信息，生成内容大纲和PPT。PPT支持单独下载，也可生成AI数字人视频或创建PPT Speak智能体。',
    url: '/editor/page/ppt',
    tabs: [
      {
        id: 'ai-ppt',
        title: 'AIPPT',
        image: getFeUrl(
          '/youyan-platform/ppt-tools/ai-ppt-card.jpg?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
  {
    title: 'PPT生成视频',
    desc: '上传你的PPT，或使用有言的AIPPT功能，无需专业学习即可轻松生成高质量的PPT讲解视频。有言提供数千个人物形象，数百种声音和数十种语言，满足您的个性化内容需求。    ',
    url: '/editor/get-started?id=4',
    tabs: [
      {
        id: 'ppt-or-pdf-to-video',
        title: 'PPT生成视频',
        image: getFeUrl(
          '/youyan-platform/ppt-tools/ppt-video-card.jpg?x-oss-process=image/format,webp',
        ),
      },
    ],
  },
];

const onDetail = (id: string) => {
  router.push({
    name: `${id}`,
  });
};
</script>

<style lang="scss" scoped>
.create-interactive {
  border-top: 1px solid var(--back-4);
}
.avatar-detail-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  :deep(.card-title) {
    text-align: left !important;
  }
}

.section-footer {
  display: flex;
  align-items: center;
  gap: 24px;
}
.view-detail-btn {
  width: 178px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 20px;
  color: var(--text-3);
  font-weight: 400;
  border-radius: 8px;
  border: 1px solid var(--back-5);
  background: var(--back-1);
  box-shadow: 0px 2px 2px 0px rgba(18, 25, 38, 0.06);
  &:hover {
    background: var(--x-back-3);
  }
}
</style>
